import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { TaxCodeSummaryReportComponent } from './tax-code-summary-report/tax-code-summary-report.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { SalesSummaryReportComponent } from './sales-summary-report/sales-summary-report.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'reports',
                canActivate: [PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    {
                        path: 'tax-code-summary',
                        component: TaxCodeSummaryReportComponent,
                        data: { title: 'Tax Code Summary' },
                    },
                    {
                        path: 'sales-summary',
                        component: SalesSummaryReportComponent,
                        data: { title: 'Sales Summary' },
                    },
                ],
            },
        ]),
    ],
    declarations: [TaxCodeSummaryReportComponent, SalesSummaryReportComponent],
})
export class ReportModule {}
